export const environment = {
    apiUrl: "https://0z3a44xhx3.execute-api.us-east-1.amazonaws.com/default",
    // apiUrl: "http://localhost:8000/demographics/api/v1",
    displayName: "Development",
    oauthUrl: "https://api.uat.editorialmanager.com",
    redirectURL: "https://demographicdata-dev.apa.org/oauth2/callback",
    client_id: "APA-IDC-PPD-2025"
};
